import {
  Button, Flex, FlexColumn, useAsyncFunctionProgress,
  useUserHasRole,
} from '@equifinance/shared';
import styled from 'styled-components';
import { formatDateTime } from '@equifinance/shared/utils';
import { SendOfferDetailsStatus, useChecklistContext } from '../../../../../../../../contexts';
import { ChecklistSection } from '../../../../../../ChecklistPage';
import { GenericSection } from '../../../../../GenericSection';
import {
  DataInfo, HeaderCss, RowData, TitleCss,
} from '../../../../common';

const PostalSectionWrapper = styled(FlexColumn)`${({ theme }) => `
  padding: ${theme.padding[1]} ${theme.padding[9]};
  gap: ${theme.padding[5]};
`}`;

export default function PostalSection() {
  const { checklist, sendOffer: postSendOffer } = useChecklistContext();
  const { sendOffer } = checklist ?? {};
  const { status, createdDate, expiryDate } = sendOffer?.offer ?? {};
  const onPostOfferPack = async () => {
    await postSendOffer();
  };

  const { inProgress, execute: executePostSendOffer } = useAsyncFunctionProgress(onPostOfferPack);

  const disablePostOffer = !useUserHasRole('CAN_OFFER_CASE') || inProgress;

  return (
    <GenericSection
      id="postal"
      subSection={ChecklistSection.SEND_OFFER_OFFER_POSTAL}
      level={1}
      headerCss={HeaderCss}
      titleCss={TitleCss}
    >
      <PostalSectionWrapper>
        {sendOffer?.decision !== 'Offered' && (
          <Flex>
            <Button disabled={disablePostOffer} small onClick={executePostSendOffer}>Post Offer Pack</Button>
          </Flex>
        )}
        <DataInfo label="Status" value={status && SendOfferDetailsStatus[status]} />
        <RowData>
          <DataInfo label="Date Pack Posted" value={createdDate && formatDateTime(createdDate, 'DD/MM/YYYY')} />
          <DataInfo label="Date Offer Expires" value={expiryDate && formatDateTime(expiryDate, 'DD/MM/YYYY')} />
        </RowData>
      </PostalSectionWrapper>
    </GenericSection>
  );
}
